/* ============================================================
   Контактные данные / каналы связи
   Меняйте здесь — телефон и WhatsApp намеренно отключены.
   ============================================================ */
import { ICON } from './icons';

export interface Channel {
  icon: string;
  filled: boolean;
  title: string;
  subtitle: string;
  href: string;
}

/** Каналы, которые показываются в поповере и в блоке контактов. */
export const CHANNELS: readonly Channel[] = [
  {
    icon: ICON.tg,
    filled: true,
    title: 'Telegram',
    subtitle: '@bitssecure',
    href: 'https://t.me/bitssecure',
  },
  {
    icon: ICON.mail,
    filled: false,
    title: 'Email',
    subtitle: 'info@bitssecure.net',
    href: 'mailto:info@bitssecure.net',
  },
];
